// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';


// Unique code of discriminator.
// Example: "AppRole"

export const discriminatorCodeMinLength = 1;
export const discriminatorCodeMaxLength = 10;

export const DiscriminatorCodeSchema = t.refinement(t.string, n => n.length >= discriminatorCodeMinLength && n.length <= discriminatorCodeMaxLength, 'DiscriminatorCode');

export type DiscriminatorCode = string;
